/**
 * v4 UI primitives — barrel export.
 * Also re-exports the GlowBackground backdrop for convenience.
 */

export { Button } from './Button';
export type { ButtonProps, ButtonVariant } from './Button';

export { Card } from './Card';
export type { CardProps } from './Card';

export { Input } from './Input';
export type { InputProps } from './Input';

export { Badge } from './Badge';
export type { BadgeProps, BadgeTone } from './Badge';

export { Chip } from './Chip';
export type { ChipProps } from './Chip';

export { Section } from './Section';
export type { SectionProps } from './Section';

export { GlowBackground } from '../theme/GlowBackground';
export type { GlowBackgroundProps, GlowBlob } from '../theme/GlowBackground';
